import { Injectable } from '@angular/core';
import { ReplaySubject } from 'rxjs/ReplaySubject';
import { ApiService } from '../api.service';
import { AuthService } from '../auth.service';
import { FieldService } from '../field.service';
import { SessionService } from '../session.service';

@Injectable()
export class BeasleyService {

    // State variable as Observers
    private currentViewSubject = new ReplaySubject<string>(1);
    public currentView = this.currentViewSubject.asObservable();
    private searchTextSubject = new ReplaySubject<string>(null);
    public searchText = this.searchTextSubject.asObservable();
    private newClaimSubject = new ReplaySubject<any>(null);
    public newClaim = this.newClaimSubject.asObservable();

    // views
    public view_bfp_form_claim_request:string = 'view_bfp_form_claim_request';
    public view_bfp_form_chat_message:string = 'view_bfp_form_chat_message';
    public view_bfp_form_file_upload:string = 'view_bfp_form_file_upload';
    public view_bfp_claims:string = 'view_bfp_claims';

    constructor(
    private apiService: ApiService,
    private authService: AuthService,
    private fieldService: FieldService,
    private sessionService: SessionService,
    ) { }

    setSearchText(searchText:string) {
        this.searchTextSubject.next(searchText);
    }

    setNewClaim(claim) {
        this.newClaimSubject.next(claim);
    }
}



// WEBPACK FOOTER //
// C:/Azure/Source/Workspaces/SalesNOW/SalesSOLO/WebSites/SalesSOLO.Web.Angular.telesales/src/app/services/beasley/beasley.service.ts